import { render, staticRenderFns } from "./postcode.vue?vue&type=template&id=4e005480&scoped=true"
import script from "./postcode.vue?vue&type=script&lang=js"
export * from "./postcode.vue?vue&type=script&lang=js"
import style0 from "./postcode.vue?vue&type=style&index=0&id=4e005480&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e005480",
  null
  
)

export default component.exports